/** Backend feature flag gating the whole study, across all three export actions. */
export const EXPORT_REASON_SURVEY_FEATURE_FLAG = 'export_reason_survey';

/** GA event category - every event from this survey shares it (filter on this in GA). */
export const GA_CATEGORY = 'export_reason_survey';

/**
 * The export the employer just ran. These are the values the backend stores in
 * export_reason_answer.action, so a GA label joins straight onto the recorded answers.
 */
export const EXPORT_ACTION = {
  zip: 'zip',
  spreadsheet: 'spreadsheet',
  forward: 'forward',
} as const;

export type ExportAction = (typeof EXPORT_ACTION)[keyof typeof EXPORT_ACTION];

/**
 * GraphQL sends enums by name, not by value, so the wire form differs from what gets stored.
 * Keyed by the stored value above.
 */
export const EXPORT_ACTION_GRAPHQL_NAME: Record<ExportAction, string> = {
  [EXPORT_ACTION.zip]: 'Zip',
  [EXPORT_ACTION.spreadsheet]: 'Spreadsheet',
  [EXPORT_ACTION.forward]: 'Forward',
};

/**
 * Where the export was started from. Recorded per action when the employer opens one of the send
 * modals, and read back when that export completes.
 */
export const EXPORT_SOURCE = {
  bulkActions: 'bulk_actions',
  applicationList: 'application_list',
  applicationDetail: 'application_detail',
} as const;

export type ExportSource = (typeof EXPORT_SOURCE)[keyof typeof EXPORT_SOURCE];

/**
 * Sources this round of the study asks about. Bulk exporting is the behaviour we don't understand,
 * and mixing in one-off exports from a single application would blur what the answers mean - a
 * single ZIP is a different act from taking 200 CVs out at once.
 *
 * The single-application triggers stay wired up and keep reporting their source, so widening the
 * study later is adding an entry here and nothing else.
 */
export const SURVEYED_SOURCES: ExportSource[] = [EXPORT_SOURCE.bulkActions];

/** Same floor the mutation enforces, so the submit button can't offer what the server rejects. */
export const MIN_REASON_LENGTH = 3;

/**
 * The modal has no close button by design, so a server that keeps refusing the answer would lock
 * the employer out of the app. After this many failed attempts it gives up and closes itself.
 */
export const MAX_SUBMIT_ATTEMPTS = 2;
